/** @file tileAzimuth: the body facing a tile is drawn at (its drawnAzimuths entry, else its sector's centre). */
import { resolveSectorTable } from '@zilo/pose3d-format/tables/resolveSectorTable';
import { sectorCentre } from '@zilo/pose3d-format/tables/sectorCentre';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import type { TileRef } from '../../state/editorTypes';

/**
 * Degrees clockwise from south (0 faces the camera): the entry's `drawnAzimuths[tile]` when present, else the centre
 * of the first sector that draws the tile unflipped (0, 45, 90, 135, 180 for a five-tile mirrored strip); null for an
 * unknown drawable, entry or table, or a tile no sector draws.
 */
export function tileAzimuth(puppet: Puppet, ref: TileRef): number | null {
  const d = puppet.drawables.find((x) => x.id === ref.drawable);
  const entry = d?.kind === 'impostor' ? d.facets[ref.entry] : undefined;
  if (entry === undefined) return null;
  const drawn = entry.drawnAzimuths?.[ref.tile];
  if (drawn !== undefined) return drawn;
  const table = resolveSectorTable(entry.yaw, puppet);
  const s = table === undefined ? -1 : table.tile.findIndex((t, i) => t === ref.tile && table.flip[i] !== true);
  return table === undefined || s < 0 ? null : sectorCentre(table, s);
}
